import { resolveShiftStatusDisplay } from "../../utils/shiftListStatusDisplay";

export default function ShiftStatusCell({ shift }) {
  const display = resolveShiftStatusDisplay(shift);

  if (!display?.chipLabel && !display?.line1) {
    return null;
  }

  return (
    <div className="flex flex-col">
      {!!display.line1 && (
        <span className="text-foreground">{display.line1}</span>
      )}
      {!!display.line2 && (
        <span className="text-muted-foreground text-xs">{display.line2}</span>
      )}
      {display.forgotToCheckout && (
        <small className="text-muted-foreground text-xs">Forgot to Checkout</small>
      )}
      {!!display.chipLabel && (
        <span
          className="mt-1 inline-flex w-fit px-2 py-0.5 rounded text-xs font-medium text-white"
          style={{ backgroundColor: display.chipColor || "#9e9e9e" }}
        >
          {display.chipLabel}
        </span>
      )}
    </div>
  );
}
